declare namespace $ {

	type $mol_switch__enabled_bog_vmap_app_inspect_flex_1 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['editable'] >
		,
		ReturnType< $mol_switch['enabled'] >
	>
	type $mol_switch__value_bog_vmap_app_inspect_flex_2 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['width'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_vmap_app_inspect_flex_3 = $mol_type_enforce<
		({ 
			'390px': string,
			'768px': string,
			'1280px': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_form_field__name_bog_vmap_app_inspect_flex_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_vmap_app_inspect_flex_5 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['Width_pick'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_switch__enabled_bog_vmap_app_inspect_flex_6 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['editable'] >
		,
		ReturnType< $mol_switch['enabled'] >
	>
	type $mol_switch__value_bog_vmap_app_inspect_flex_7 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['direction'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_vmap_app_inspect_flex_8 = $mol_type_enforce<
		({ 
			'column': string,
			'row': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_form_field__name_bog_vmap_app_inspect_flex_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_vmap_app_inspect_flex_10 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['Direction_pick'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_switch__enabled_bog_vmap_app_inspect_flex_11 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['editable'] >
		,
		ReturnType< $mol_switch['enabled'] >
	>
	type $mol_switch__value_bog_vmap_app_inspect_flex_12 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['across'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_vmap_app_inspect_flex_13 = $mol_type_enforce<
		({ 
			'flex-start': string,
			'center': string,
			'flex-end': string,
			'stretch': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_form_field__name_bog_vmap_app_inspect_flex_14 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_vmap_app_inspect_flex_15 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['Across_pick'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_switch__enabled_bog_vmap_app_inspect_flex_16 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['editable'] >
		,
		ReturnType< $mol_switch['enabled'] >
	>
	type $mol_switch__value_bog_vmap_app_inspect_flex_17 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['along'] >
		,
		ReturnType< $mol_switch['value'] >
	>
	type $mol_switch__options_bog_vmap_app_inspect_flex_18 = $mol_type_enforce<
		({ 
			'flex-start': string,
			'center': string,
			'flex-end': string,
			'space-between': string,
		}) 
		,
		ReturnType< $mol_switch['options'] >
	>
	type $mol_form_field__name_bog_vmap_app_inspect_flex_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_vmap_app_inspect_flex_20 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['Along_pick'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_string__hint_bog_vmap_app_inspect_flex_21 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_bog_vmap_app_inspect_flex_22 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['gap'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_string__enabled_bog_vmap_app_inspect_flex_23 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['editable'] >
		,
		ReturnType< $mol_string['enabled'] >
	>
	type $mol_form_field__name_bog_vmap_app_inspect_flex_24 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_vmap_app_inspect_flex_25 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['Gap_field'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	type $mol_check__title_bog_vmap_app_inspect_flex_26 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_check['title'] >
	>
	type $mol_check__checked_bog_vmap_app_inspect_flex_27 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['grow'] >
		,
		ReturnType< $mol_check['checked'] >
	>
	type $mol_check__enabled_bog_vmap_app_inspect_flex_28 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['editable'] >
		,
		ReturnType< $mol_check['enabled'] >
	>
	type $mol_form_field__name_bog_vmap_app_inspect_flex_29 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_form_field['name'] >
	>
	type $mol_form_field__control_bog_vmap_app_inspect_flex_30 = $mol_type_enforce<
		ReturnType< $bog_vmap_app_inspect_flex['Grow_check'] >
		,
		ReturnType< $mol_form_field['control'] >
	>
	export class $bog_vmap_app_inspect_flex extends $mol_list {
		width( next?: string ): string
		Width_pick( ): $mol_switch
		Width( ): $mol_form_field
		direction( next?: string ): string
		Direction_pick( ): $mol_switch
		Direction( ): $mol_form_field
		across( next?: string ): string
		Across_pick( ): $mol_switch
		Across( ): $mol_form_field
		along( next?: string ): string
		Along_pick( ): $mol_switch
		Along( ): $mol_form_field
		gap( next?: string ): string
		Gap_field( ): $mol_string
		Gap( ): $mol_form_field
		grow( next?: boolean ): boolean
		Grow_check( ): $mol_check
		Grow( ): $mol_form_field
		value( id: any, next?: string ): string
		editable( ): boolean
		rows( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=flex.view.tree.d.ts.map